<button class="btn btn-secondary d-md-inline d-none" (click)="toggleModal()" *ngIf="showChatButton">
    <i class="pi pi-comments"></i>
    <span
        *ngIf="hasUnreadMessages$ | async"
        class="position-absolute start-100 translate-middle p-2 bg-danger border border-danger rounded-circle"
        style="top: -2px"
    ></span>
</button>

<app-chat-modal *ngIf="showChatButton"></app-chat-modal>
